/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_GIFT_EXPRESSIONS = 'mbp-checkout/LOAD_GIFT_EXPRESSIONS';
export const UPDATE_GIFT_EXPRESSIONS = 'mbp-checkout/UPDATE_GIFT_EXPRESSIONS';
